/**
 * React Query hook for fetching Gmail aliases.
 */

import { useQuery } from '@tanstack/react-query';

import { apiGet } from '@/lib/http/client';

export interface GmailAlias {
  email: string;
  is_primary: boolean;
}

export interface GmailAliasesResponse {
  aliases: GmailAlias[];
}

async function fetchGmailAliases(
  orgId: string,
  socialAccountId: number
): Promise<GmailAliasesResponse> {
  return apiGet<GmailAliasesResponse>(
    `/users/api/gmail/aliases/?org_id=${orgId}&social_account_id=${socialAccountId}`
  );
}

export function useGmailAliases(
  orgId: string,
  socialAccountId: number,
  enabled: boolean
) {
  const { data, isLoading, error } = useQuery({
    queryKey: ['google', 'gmail', 'aliases', orgId, socialAccountId],
    queryFn: () => fetchGmailAliases(orgId, socialAccountId),
    staleTime: 5 * 60_000, // 5 minutes - aliases rarely change
    gcTime: 10 * 60_000, // 10 minutes
    enabled,
  });

  return { data, isLoading, error };
}
